<!-- @format -->

@if (showCustomerRating() && ratingCount && ratingValue) {
	<div class="hmf-display-flex">
		<div class="hmf-display-flex">
			@for (star of stars; track trackByFn($index, item)) {
				<homefield-icon
					[width]="'16px'"
					[height]="'16px'"
					[name]="star">
				</homefield-icon>
			}
		</div>
		<p class="hmf-ml-xxxs hmf-mb-0">({{ ratingCount }})</p>
	</div>
}
